export type UserStatusFilterValue = 'ACTIVE' | 'INACTIVE';

export const USER_STATUS_FILTER_OPTIONS: ReadonlyArray<{
  value: UserStatusFilterValue;
  labelKey: 'status.pill.active' | 'status.pill.inactive';
}> = [
  { value: 'ACTIVE', labelKey: 'status.pill.active' },
  { value: 'INACTIVE', labelKey: 'status.pill.inactive' },
];

export function normalizeUserStatuses(value: unknown): UserStatusFilterValue[] {
  if (!Array.isArray(value)) return [];
  return USER_STATUS_FILTER_OPTIONS
    .filter((option) => value.includes(option.value))
    .map((option) => option.value);
}

export function getUserActiveFilter(
  statuses: readonly UserStatusFilterValue[],
): boolean | undefined {
  if (statuses.length !== 1) return undefined;
  return statuses[0] === 'ACTIVE';
}
